import { render, staticRenderFns } from "./jianshan.vue?vue&type=template&id=4d6b721a&scoped=true"
import script from "./jianshan.vue?vue&type=script&lang=js"
export * from "./jianshan.vue?vue&type=script&lang=js"
import style0 from "./jianshan.vue?vue&type=style&index=0&id=4d6b721a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6b721a",
  null
  
)

export default component.exports